import {
  TaskPriority,
  TimingUnit,
} from '@principle-theorem/principle-core/interfaces';
import {
  CustomRecurrenceFrequency,
  DayOfWeek,
  EndingType,
  Frequency,
  IAvroSerialisedRawInlineNodes,
  IAvroSerialisedVersionedSchema,
  ISODateType,
  ISerialisedDocumentReference,
  ISerialisedTimestamp,
} from '@principle-theorem/shared';
import {
  IBigQueryFirestoreModel,
  IBigQueryNamedDocument,
  IBigQueryReffable,
  ITimestampedDimension,
} from './common';

export interface IRecurringTaskDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    ITimestampedDimension {
  title: IAvroSerialisedRawInlineNodes;
  description?: IAvroSerialisedVersionedSchema;
  priority: TaskPriority;
  recurrencePattern: IBigQueryRecurrencePattern;
  assignedUser?: IBigQueryNamedDocument;
  assignedTeam?: IBigQueryNamedDocument;
  owner: IBigQueryNamedDocument;
  completedAt?: ISerialisedTimestamp;
  createdTasks: ICreatedTask[];
  dueDate?: IDueDate;
  dueTime?: string;
}

interface IDueDate {
  unit: TimingUnit;
  amount: number;
}

interface ICreatedTask {
  dateShown: ISerialisedTimestamp;
  ref: ISerialisedDocumentReference;
}

interface IBigQueryRecurrencePattern {
  frequencyType: Frequency;
  /**
   * @TJS-type string
   */
  startDate?: ISODateType;
  endingType: EndingType;
  /**
   * @TJS-type string
   */
  endingDate?: ISODateType;
  customFrequencyType?: CustomRecurrenceFrequency;
  occurrenceCount?: number;
  seperationCount?: number;
  daysOfWeek?: DayOfWeek[];
  weeksOfMonth?: number[];
  daysOfMonth?: number[];
  monthsOfYear?: number[];
  times?: string[];
}
